import { Button, Modal, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { FormattedMessage } from 'react-intl';
import axiosInstance from '../../services/axiosInterceptor';

const AddEmailPopUp = ({ emailPopUp, emailLabel, logout }) => {
    const [show, setShow] = useState(true);
    const [emailInvalid, setEmailInvalid] = useState(false);
    const [disable, setDisable] = useState(true);
    const [config, setConfig] = useState({});
    const [isEmail, setIsEmail] = useState('');

    const [authCookie, setAuthCookie] = useCookies(['email_collected']);

    const emailRegrex =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const handleClose = () => {
        setShow(false);
        emailPopUp();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        axiosInstance()
            .post('incas/addEmail', { email: isEmail })
            .then((res) => {
                setShow(false);
                setAuthCookie('email_collected', 'true', {
                    maxAge: 86400,
                    secure: true
                });
                if (emailLabel == 'Logout') {
                    logout();
                }
            })
            .catch((err) => {
                console.log('error');
            });
    };

    const handleEmail = async (e) => {
        e.preventDefault();

        if (emailLabel == 'Logout') {
            logout();
        }

        setShow(false);
    };

    const handleInput = (e) => {
        setIsEmail(e.target.value);
        if (emailRegrex.test(e.target.value)) {
            setEmailInvalid(false);
            setDisable(false);
        } else {
            setEmailInvalid(true);
            setDisable(true);
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Form>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FormattedMessage
                            id="EmailPopUp.title"
                            defaultMessage="Email Address"
                        />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>
                            <FormattedMessage
                                id="EmailPopUp.emailPrompt"
                                defaultMessage="Please enter your email below to link to your
                            account:"
                            />
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter your email here"
                            onChange={handleInput}
                            isInvalid={emailInvalid}
                        />
                        <Form.Control.Feedback type="invalid">
                            <FormattedMessage
                                id="EmailPopUp.invalidEmail"
                                defaultMessage="Your email address is invalid."
                            />
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            <FormattedMessage
                                id="EmailPopUp.notice"
                                defaultMessage="By adding, you will receive new access URL for
                            incas.yourmorals.org via email for further access"
                            />
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant={
                            emailLabel == 'Logout'
                                ? 'outline-danger'
                                : 'outline-dark'
                        }
                        onClick={handleEmail}
                        className="mr-auto"
                    >
                        {emailLabel == 'Logout' ? 'Logout' : 'Cancel'}
                    </Button>
                    <Button
                        variant="outline-success"
                        onClick={handleSubmit}
                        disabled={disable}
                    >
                        {emailLabel == 'Logout' ? 'Submit & Logout' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default AddEmailPopUp;
